import React from 'react';
import Tippy from '@tippyjs/react';

import { PageContext } from '../../context/PageContext';

class PageVisibility extends React.Component {
    static contextType = PageContext;

    render() {
        const { page } = this.context;
        if (!page) return null;
        const { authorizationLink, visibility, visibilityTitle } = page;

        return (
            <div className="page-visibility">
                <Tippy content={visibilityTitle} placement="bottom">
                    <span>
                        {
                            visibility || ''
                        }
                    </span>
                </Tippy>
                { authorizationLink
                    && (
                        <Tippy content="Visible to anyone with authorized link" placement="bottom">
                            <span
                                id="link-sharing"
                                className="cursor-default-important"
                                data-page-id={pageId}
                            >
                                {' '}
    - link sharing on
                            </span>
                        </Tippy>
                    )}
            </div>
        );
    }
}

export default PageVisibility;
